import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { fontWeights } from "@dana/MobiusOverrides/styles/typography";
import { quantityOrderedStyles } from "@dana/Overrides/Widgets/ProductDetails/ProductDetailsQuantityOrdered";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

quantityOrderedStyles.quantityOrdered = mergeToNew(quantityOrderedStyles.quantityOrdered, {
    mergeCss: true,
    cssOverrides: {
        formField: css`
            width: auto;
            margin-top: 8px;

            [data-test-selector="product_qtyOrdered-label"] {
                font-weight: ${fontWeights.bold};
            }
        `,
        formInputWrapper: css`
            margin-top: 8px;
        `,
        inputSelect: css`
            width: auto;
            max-width: 100px;
            border-radius: 0 !important;
        `,
    },
});
